import { render, staticRenderFns } from "./TwBenchmarkTableSettingDialog.vue?vue&type=template&id=562c3981&scoped=true"
import script from "./TwBenchmarkTableSettingDialog.vue?vue&type=script&lang=ts"
export * from "./TwBenchmarkTableSettingDialog.vue?vue&type=script&lang=ts"
import style0 from "./TwBenchmarkTableSettingDialog.vue?vue&type=style&index=0&id=562c3981&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562c3981",
  null
  
)

export default component.exports